export default __webpack_public_path__ + "static/HP Quick Hit Brochure Update (Digital)-5f77afb9d3257f97ccfb27e696aca0ce.pdf";